import { getProvider } from './utils/providerFactory';

const prefix = '/api/v1';
const provider = getProvider(process.env.HTTP_CLIENT_DRIVER);

export function get(url, data, options) {
    return provider.get(url, data, {
        prefix,
        ...options
    });
}

export function post(url, data, options) {
    return provider.post(url, data, {
        prefix,
        ...options
    });
}



// WEBPACK FOOTER //
// ./src/services/api/api.js